// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-container .ql-editor {\n  min-height: 200px;\n  padding-bottom: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/ngx-quill-editor/quillEditor.component.css
// module id = 927
// module chunks = 4